import { render, staticRenderFns } from "./PublicList.vue?vue&type=template&id=4f18fffe"
import script from "./PublicList.vue?vue&type=script&lang=js"
export * from "./PublicList.vue?vue&type=script&lang=js"
import style0 from "./PublicList.vue?vue&type=style&index=0&id=4f18fffe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports